import gsap from 'gsap';
import React, { useLayoutEffect, useRef, useState } from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import * as styles from './PhotoReel.module.scss';

export default function PhotoReel({ images }) {
  const [copies, setCopies] = useState(1);
  const component = useRef();
  const imagesRef = useRef();

  // Check dimensions and duplicate images array if necessary to fill viewport
  useLayoutEffect(() => {
    let clientWidth = imagesRef?.current?.clientWidth || 1;
    setCopies(Math.ceil(window.innerWidth / clientWidth));

    let ctx = gsap.context(() => {
      gsap.to('.images', {
        xPercent: -100,
        duration: (copies + 1) * 30,
        ease: 'none',
        repeat: -1,
      });
    }, component);

    const pauseReel = () => ctx.data[0].timeScale(0.25);
    const resumeReel = () => ctx.data[0].timeScale(1);
    component.current.addEventListener('mouseenter', pauseReel);
    component.current.addEventListener('mouseleave', resumeReel);

    return () => {
      component.current.removeEventListener('mouseenter', pauseReel);
      component.current.removeEventListener('mouseleave', resumeReel);
      ctx.revert();
    };
  }, [imagesRef, component]);

  if (!images) {
    return null;
  }

  return (
    <div className={styles.photoReel} ref={component} data-analytics-section={'photo-reel'}>
      <div className={['images', styles.images].join(' ')} ref={imagesRef}>
        {images?.map((image, i) => (
          <ContentfulImage key={`first-${i}`} imageFragment={image} data-analytics-component={'employees-photo'} />
        ))}
      </div>
      {copies > 0 &&
        [...Array(copies)]?.map((_, i) => (
          <div key={`copy-${i}`} className={['images', styles.images].join(' ')}>
            {images?.map((image, j) => (
              <ContentfulImage key={`${i}-${j}`} imageFragment={image} data-analytics-component={'employees-photo'} />
            ))}
          </div>
        ))}
    </div>
  );
}
